module.exports = __webpack_public_path__ + "static/media/mcc_brand_navy.1364522b.png";